export default {
  SUCCESS: 'imageUploadedSuccessfully',
  ERROR: 'imageUploadError'
};
